export default function MobileMission() {
  return (
    <div
      style={{
        flexShrink: "0",
        display: "inline-flex",
        flexDirection: "column",
        gap: "1.92rem",
        marginLeft: "1.4rem",
        marginTop: "1.6rem",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "flex-start",
          gap: "0.71816rem",
          width: "27.2rem",
          padding: "1.21192rem 1.2568rem",
          flexDirection: "column",
          borderRadius: "0.44888rem",
          background: "#EAF0E8",
        }}
      >
        <p
          style={{
            color: "var(--title-color, #22495F)",
            fontSize: "0.86176rem",
            fontWeight: "500",
            letterSpacing: "0.08616rem",
            textTransform: "uppercase",
          }}
        >
          our mission
        </p>
        <h3
          style={{
            color: "var(--title-color, #22495F)",
            fontSize: "1.20648rem",
            fontWeight: "600",
            lineHeight: "1.80976rem",
            width: "21.37216rem",
            fontFamily: "Clash Display",
          }}
        >
          Our mission is to drive positive societal transformation in Africa
        </h3>
        <p
          style={{
            color: "var(--text-color, #374151)",
            fontSize: "1.0576rem",
            fontWeight: "400",
            lineHeight: "1.69216rem",
            width: "24.72rem",
          }}
        >
          Our mission is to drive positive societal transformation in Africa by
          addressing unique challenges and empowering its people. We focus on
          enhancing access to quality education, improving healthcare outcomes,
          supporting national security, and fostering entrepreneurship through
          capacity-building and access to finance.
        </p>
      </div>
      <div
        style={{
          display: "inline-flex",
          alignItems: "flex-start",
          gap: "0.71816rem",
          width: "27.2rem",
          padding: "1.21192rem 1.2568rem",
          flexDirection: "column",
          borderRadius: "0.44888rem",
          background: "#EAF0E8",
        }}
      >
        <p
          style={{
            color: "var(--title-color, #22495F)",
            fontSize: "0.86176rem",
            fontWeight: "500",
            letterSpacing: "0.08616rem",
            textTransform: "uppercase",
          }}
        >
          our Vision
        </p>
        <h3
          style={{
            color: "var(--title-color, #22495F)",
            fontSize: "1.20648rem",
            fontWeight: "600",
            lineHeight: "1.80976rem",
            width: "24.19272rem",
            fontFamily: "Clash Display",
          }}
        >
          To harness the rich diaspora experience for African empowerment in
          Africa
        </h3>
        <p
          style={{
            color: "var(--text-color, #374151)",
            fontSize: "1.0576rem",
            fontWeight: "400",
            lineHeight: "1.69216rem",
            width: "24.72rem",
          }}
        >
          Our vision is to harness the rich diaspora experience for the
          empowerment of individuals and communities in AFRICA. Our vision is a
          transformed AFRICA, where every individual has access to quality
          education and healthcare, and feels secure in a prosperous and
          inclusive society. Together, we create a thriving and inclusive
          nation.
        </p>
      </div>
    </div>
  );
}
